"use client";
import Image from "next/image";
import Container from "../ui/container";
import Link from "next/link";
import { Button } from "../ui/button";
import { ShoppingCart } from "lucide-react";

export default function CustomModularSection() {
  return (
    <>
      <Container className='py-12 px-4'>
        <div className='flex flex-col items-center justify-center'>
          <span className='text-primary text-sm font-medium'>
            Choose your Style
          </span>
          <h2 className='text-4xl font-bold text-center mb-8'>
            Identification Display
          </h2>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-0 items-start px-4'>
          {/* Modular Display */}
          <div className='flex flex-col items-center gap-4 shadow-md'>
            <h3 className=' text-center text-2xl font-bold'>Modular</h3>

            <div className='relative w-full h-64 overflow-hidden group'>
              <Image
                src='https://res.cloudinary.com/djowccubk/image/upload/v1739721169/products/AFS_Rock_Board_RBM577_Front.webp'
                alt='Modular Display - Customizable Number'
                fill
                className='object-contain transition-transform duration-300 ease-in-out group-hover:scale-105'
                sizes='(max-width: 768px) 100vw, 50vw'
                loading='lazy'
                quality={70}
              />
            </div>
            <ul className='self-start text-base text-muted-foreground list-disc pl-4 lg:pl-16 -translate-y-6'>
              <li>
                Set your own{" "}
                <span className='font-bold'>
                  3 or 4 digit Identification Number
                </span>
              </li>
              <li>
                <span className='italic'>
                  (Customizable / changeable by the customer)
                </span>
              </li>
              <li>
                <span className='text-primary'>
                  Only numbers, no characters
                </span>
              </li>
            </ul>
            <div className='-translate-y-4 self-center'>
              <Link href={`/rock-board/products?type=modular`}>
                <Button>
                  <ShoppingCart className='mr-2 h-4 w-4' />
                  Modular
                </Button>
              </Link>
            </div>
          </div>
          {/* Custom Display */}
          <div className='flex flex-col items-center gap-4 shadow-md md:border-l'>
            <h3 className=' text-center text-2xl font-bold'>Custom</h3>
            <div className='relative w-full h-64 overflow-hidden group'>
              <Image
                src='https://res.cloudinary.com/djowccubk/image/upload/v1739805680/products/AFS_Rock_Board_DS-577_Front.webp'
                alt='Custom Display - Fixed Alphanumeric'
                fill
                className='object-contain transition-transform duration-300 ease-in-out group-hover:scale-105'
                sizes='(max-width: 768px) 100vw, 50vw'
                loading='lazy'
                quality={70}
              />
            </div>

            <ul className='self-start text-base text-muted-foreground list-disc pl-4 lg:pl-16 -translate-y-6'>
              <li>
                Fixed <span className='font-bold'>Alpha-numeric display</span>
              </li>
              <li>Set identification number on purchase</li>
            </ul>
            <div className='-translate-y-4 self-center'>
              <Link href='/rock-board/products?type=custom'>
                <Button>
                  <ShoppingCart className='mr-2 h-4 w-4' />
                  Custom
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </Container>
      {/* Responsive image grid: 2 columns on <xl, 4 columns on xl+ */}
      <div className='w-full hidden md:grid grid-cols-2 xl:grid-cols-4 gap-0 p-0'>
        {/* Position 1: Always visible */}
        <div className='relative w-full h-64 md:h-96 p-0 overflow-hidden group'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1736383021/images/bou4dn6zxku4b851wouv.webp'
            alt='Left comparison image'
            fill
            className='object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105'
            sizes='(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 25vw'
            loading='lazy'
            quality={60}
          />
        </div>
        {/* Position 2: Only visible on xl+ */}
        <div className='relative w-full h-64 md:h-96 p-0 hidden xl:block overflow-hidden group'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1736383023/images/rmvzzkfrpymdotx7jaw3.webp'
            alt='Left inner image (xl+)'
            fill
            className='object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105'
            sizes='(max-width: 1280px) 0vw, 25vw'
            loading='lazy'
            quality={60}
          />
        </div>
        {/* Position 3: Always visible */}
        <div className='relative w-full h-64 md:h-96 p-0 overflow-hidden group'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1736383005/images/m6w5vanbajxn31dcqgbv.webp'
            alt='Right comparison image'
            fill
            className='object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105'
            sizes='(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 25vw'
            loading='lazy'
            quality={60}
          />
        </div>
        {/* Position 4: Only visible on xl+ */}
        <div className='relative w-full h-64 md:h-96 p-0 hidden xl:block overflow-hidden group'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1736383023/images/y19qslqe7bocccs1xgxn.webp'
            alt='Right inner image (xl+)'
            fill
            className='object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105'
            sizes='(max-width: 1280px) 0vw, 25vw'
            loading='lazy'
            quality={60}
          />
        </div>
      </div>
    </>
  );
}
